import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Sparkles, Shield } from 'lucide-react';
const pillars = [{
  icon: Clock,
  title: 'Ventana Protegida',
  subtitle: '12–30 min',
  description: 'Espacio realista, nocturno, sin logística.'
}, {
  icon: Sparkles,
  title: 'Micro-Momentos',
  subtitle: 'Alto impacto',
  description: 'Actividades de mirada, toque y risa.'
}, {
  icon: Shield,
  title: 'Cierre de Fricción',
  subtitle: 'Sin rencores',
  description: 'Guiones para no irse a dormir enojados.'
}];
export function Mechanism() {
  return <section className="py-16 px-4 bg-[#0f0f16]" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-101">
          <h2 className="text-2xl sm:text-3xl font-serif text-white mb-4 leading-snug" data-id="element-102">
            La verdad simple: La conexión no se compra.{' '}
            <span className="text-[#ff2d7a]" data-id="element-103">
              Se construye con señales pequeñas.
            </span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-4" data-id="element-104">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`p-6 rounded-2xl border text-center ${index === 1 ? 'bg-[#1a1a24] border-[#ff2d7a]/40 shadow-[0_0_20px_rgba(255,45,122,0.1)]' : 'bg-[#15151e] border-white/5'}`} data-id="element-105">
              <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${index === 1 ? 'bg-[#ff2d7a] text-white' : 'bg-white/5 text-gray-400'}`} data-id="element-106">
                <pillar.icon size={24} data-id="element-107" />
              </div>
              <h3 className="text-white font-bold mb-1" data-id="element-108">{pillar.title}</h3>
              <span className="text-[#ff2d7a] text-xs font-semibold uppercase tracking-wider block mb-2" data-id="element-109">
                {pillar.subtitle}
              </span>
              <p className="text-gray-400 text-sm" data-id="element-110">{pillar.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}